@if (this.configuration(); as configuration) {
  <div
    class="grid grid-cols-1 2xl:grid-cols-2 2xl:gap-8 gap-16 bg-background py-8"
  >
    @for (widget of configuration.widgetView; track $index) {
      @if (widget.type === WidgetType.PLACEHOLDER) {
        @switch ($index) {
          @case (0) {
            <pm-single-forecasts-widget [name]="widget.name" />
          }
          @case (1) {
            <pm-portfolio-totals-multi-year-widget [name]="widget.name" />
          }
          @case (2) {
            <pm-planning-accuracy-widget [name]="widget.name" />
          }
          @case (3) {
            <pm-yearly-comparison-widget [name]="widget.name" />
          }
        }
      } @else {
        @switch (widget.type) {
          @case (WidgetType.PORTFOLIO_TOTALS) {
            <pm-portfolio-totals-widget
              [targetUnit]="widget.targetUnit"
              [filter]="widget.filter"
              [year]="widget.year"
              [name]="widget.name"
            />
          }
          @case (WidgetType.YEAR_TO_DATE_TREND) {
            <pm-year-to-date-trend-widget
              [targetUnit]="widget.targetUnit"
              [filterColumn]="widget.filterColumn"
              [filterOptions]="widget.filterOptions"
              [name]="widget.name"
            />
          }
          @case (WidgetType.SINGLE_FORECASTS) {
            <pm-single-forecasts-widget
              [targetUnit]="widget.targetUnit"
              [resolution]="widget.resolution"
              [filterColumn]="widget.filterColumn"
              [filterOptions]="widget.filterOptions"
              [name]="widget.name"
            />
          }
          @case (WidgetType.PORTFOLIO_TOTALS_MULTI_YEAR) {
            <pm-portfolio-totals-multi-year-widget
              [targetUnit]="widget.targetUnit"
              [filter]="widget.filter"
              [years]="widget.years"
              [name]="widget.name"
            />
          }
          @case (WidgetType.YEARLY_COMPARISON) {
            <pm-yearly-comparison-widget
              [targetUnit]="widget.targetUnit"
              [resolution]="widget.resolution"
              [filterColumn]="widget.filterColumn"
              [filterOptions]="widget.filterOptions"
              [name]="widget.name"
            />
          }
          @case (WidgetType.PLANNING_ACCURACY) {
            <pm-planning-accuracy-widget
              [planningPeriod]="widget.planningPeriod"
              [resolution]="widget.resolution"
              [selectedFilterGroup]="widget.selectedFilterGroup"
              [selectedFilterOption]="widget.selectedFilterOption"
              [additionalTimeSeriesName]="widget.additionalTimeSeriesName"
              [name]="widget.name"
            />
          }
          @case (WidgetType.ABC_XYZ_ANALYSIS) {
            <pm-abc-xyz-analysis-widget
              [name]="widget.name"
              [groups]="widget.groups"
              [volumeBinLimits]="widget.volumeBinLimits"
              [forecastAccuracyBinLimits]="widget.forecastAccuracyBinLimits"
              [planningPeriod]="widget.planningPeriod"
              [errorMeasure]="widget.errorMeasure"
              [timePeriodBackwardsInMonths]="widget.timePeriodBackwardsInMonths"
              [targetUnit]="widget.targetUnit"
            />
          }
          @default {
            <div>
              {{ 'RESULT.INSIGHTS.GENERAL.WIDGET_NOT_FOUND' | translate }}
            </div>
          }
        }
      }
    }
  </div>
}
